import { __awaiter } from '../_virtual/_tslib.js';

class ContractManager {
  constructor(provider, fetchAddress, getModule) {
    // eslint-disable-next-line class-methods-use-this
    this.getModule = name => __awaiter(this, void 0, void 0, function* () {
      const mod = yield import( /* webpackMode: "lazy", webpackChunkName: "[request]", webpackPreload: true, webpackExclude: /.*\.ts$/ */
      `../generated/factories/${name}__factory`);
      return mod[`${name}__factory`];
    });
    this.generateContractGetter = name => {
      return (passedProvider, address) => __awaiter(this, void 0, void 0, function* () {
        const mod = yield this.getModule(name);
        const inputAddress = address || this.fetchAddress(name);
        const provider = passedProvider || this.provider;
        return mod.connect(inputAddress, provider);
      });
    };
    this.getPublicResolver = this.generateContractGetter("PublicResolverLogic");
    this.getUnified = this.generateContractGetter("RNSUnifiedLogic");
    this.getReverseRegistrar = this.generateContractGetter("ReverseRegistrarLogic");
    this.getEthRegistrarController = this.generateContractGetter("RONRegistrarControllerLogic");
    this.getMulticall = this.generateContractGetter("Multicall");
    this.getRnsDomainPrice = this.generateContractGetter("RNSDomainPriceLogic");
    this.provider = provider;
    this.fetchAddress = fetchAddress;
    if (getModule) {
      this.getModule = getModule;
    }
  }
}

export { ContractManager as default };
